module.exports = __webpack_public_path__ + "static/media/conejobebe_tex.a6d8c6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/conejo_bebe/conejobebe_tex.png
// module id = 150
// module chunks = 0